// conditional synchronous import (top level await) not working -> all the config files are imported into index.js
// keep the config files as light as possible and lazy load components
const configModules = import.meta.glob('./clients/*.js', { import: 'default', eager: true });
const integrationModules = import.meta.glob('./integrations/*.js', { import: 'default', eager: true });
const companyConfigModules = import.meta.glob('./companies/*.js', { import: 'default' });

let config = {};
const subdomain = window.location.hostname.replace(/(.*)\.bubbleplan\.net/i, '$1');
if (['localhost', 'wpd', 'mel', 'metro', 'horis', 'amm', 'baccarat', 'setram', 'maaf', 'neosoft', 'tf1', 'maif'].includes(subdomain)) {
  config = configModules[`./clients/${subdomain}.js`] || {};
}

const integration = decodeURIComponent(window.location.search.replace(/^(?:.*[&?]integration(?:=([^&]*))?)?.*$/i, "$1"));
if (integration == 'microsoftteams') {
  config = angular.merge({}, integrationModules['./integrations/microsoftteams.js'], config);
}

let currentCompanyConfigFile = null;
export async function loadCompanyConfigFile(name) {
  if (! name || name == currentCompanyConfigFile) return; // already loaded
  const moduleLoader = companyConfigModules[`./companies/${name}.js`];
  if (! moduleLoader) {
    console.error(`Company config file not found: ${name}`);
    return;
  }

  const companyConfig = await moduleLoader();
  if (companyConfig) {
    angular.merge(config, companyConfig);
    currentCompanyConfigFile = name;
  }
}

export default config;
